import React, { useState, useEffect } from "react";
import "../../App.css";
import { apiPostFileAuth } from "../../utils/api"; // Use your axios wrapper
import { useNavigate } from "react-router-dom";

export default function AddMemberPage() {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [profilePicture, setProfilePicture] = useState(null);
const [governmentId, setGovernmentId] = useState(null);
const [fullName, setFullName] = useState("");
const [address, setAddress] = useState("");
const [phoneNumber, setPhoneNumber] = useState("");
  const navigate = useNavigate();

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    if (!profilePicture) {
        setErrorMessage("Belum memilih foto profil.");
        return;
    }

    if (!governmentId) {
        setErrorMessage("Belum memilih foto KTP.");
        return;
    }

    if (!fullName.trim()) {
        setErrorMessage("Belum mengisi nama lengkap.");
        return;
    }

    if (!address.trim()) {
        setErrorMessage("Belum mengisi alamat lengkap.");
        return;
    }

    if (!phoneNumber.trim()) {
        setErrorMessage("Belum mengisi nomor HP/Whatsapp.");
        return;
    }
    setLoading(true);
    try {
        const formData = new FormData();
        formData.append("profile_picture", await convertImageToJpeg(profilePicture));
        formData.append("government_id", await convertImageToJpeg(governmentId));
        formData.append("full_name", fullName);
        formData.append("address", address);
        formData.append("phone_number", phoneNumber);

        const response = await apiPostFileAuth("member/add_member.php", formData);

        if (response.result === 1) {
            //success action here
            navigate("/dashboard/member");
        } else {
            setErrorMessage(response.message || "Gagal menambahkan member.");
        }
    } catch (error) {
        setErrorMessage("Oops, terjadi kesalahan. Coba lagi.");
    }
    setLoading(false);
    };

  if (loading) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <div className="loading-spinner"></div>
        <p style={{ marginTop: "10px", color: "#4b5563" }}>Loading...</p>
      </div>
    );
  }

  const convertImageToJpeg = (
    file,
    maxWidth = 2000,
    quality = 0.7
    ) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = (event) => {
        const img = new Image();

        img.src = event.target.result;

        img.onload = () => {
            let width = img.width;
            let height = img.height;

            // Resize large images
            if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
            }

            const canvas = document.createElement("canvas");

            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext("2d");

            // White background (important for PNG/HEIC transparency)
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, width, height);

            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
            (blob) => {
                if (!blob) {
                reject(new Error("JPEG conversion failed"));
                return;
                }

                // Generate .jpg filename
                const fileName =
                file.name.replace(/\.[^/.]+$/, "") + ".jpg";

                const jpegFile = new File(
                [blob],
                fileName,
                {
                    type: "image/jpeg",
                    lastModified: Date.now(),
                }
                );

                resolve(jpegFile);
            },
            "image/jpeg",
            quality
            );
        };

        img.onerror = reject;
        };

        reader.onerror = reject;
    });
    };

  return (
    <div style={{ padding: "20px" }}>
      <button
        onClick={() => navigate(`/dashboard/member`)}
        style={backButtonStyle}
        >
        ← Kembali
      </button>

      <h1 style={{ fontSize: "1.8rem", marginBottom: "10px", color: "#1f2937" }}>
        Tambah Member Baru
      </h1>
      <p style={{ fontSize: "1rem", marginBottom: "30px", color: "#4b5563" }}>
        Tambahkan member baru dengan mengisi data diri member.
      </p>

      {/* White container filling parent width */}
      <div
        style={{
            backgroundColor: "#fff",
            padding: "30px 20px",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
            width: "90%",
            marginBottom: "20px",
        }}
        >
        <h2
            style={{
            fontSize: "1.2rem",
            marginBottom: "20px",
            color: "#1f2937",
            }}
        >
            Data Diri Member
        </h2>

        <form onSubmit={handleSubmit}>
            {/* Profile Picture */}
            <label
                    htmlFor="profile_picture"
                    style={{
                    display: "block",
                    marginTop: "20px",
                    marginBottom: "8px",
                    color: "#1f2937",
                    fontWeight: "500",
                    }}
                >
                    Foto Profil
            </label>
            <div
                style={{
                    width: "90%",
                    padding: "18px 20px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "12px",
                    backgroundColor: "#f9fafb",
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                }}
                >
                
                <div
                    style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "10px",
                    backgroundColor: "#eef2ff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1.4rem",
                    flexShrink: 0,
                    }}
                >
                    📷
                </div>

                <div style={{ flex: 1 }}>
                    <p
                    style={{
                        margin: 0,
                        fontWeight: "600",
                        color: "#1f2937",
                        marginBottom: "5px",
                    }}
                    >
                    Upload Foto Profil
                    </p>

                    <p
                    style={{
                        margin: 0,
                        fontSize: "0.9rem",
                        color: "#6b7280",
                    }}
                    >
                    {profilePicture ? profilePicture.name : "Belum ada"}
                    </p>
                </div>

                <label
                    htmlFor="profile_picture"
                    style={{
                    padding: "10px 16px",
                    backgroundColor: "#111827",
                    color: "#fff",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "0.9rem",
                    fontWeight: "500",
                    whiteSpace: "nowrap",
                    }}
                >
                    Pilih Foto
                </label>

                <input
                    id="profile_picture"
                    type="file"
                    accept="image/*"
                    onChange={(e) => setProfilePicture(e.target.files[0])}
                    style={{ display: "none" }}
                />
            </div>

            {/* Government ID */}
            <div style={{ marginBottom: "20px" }}>
                <label
                    htmlFor="government_id"
                    style={{
                    display: "block",
                    marginTop: "20px",
                    marginBottom: "8px",
                    color: "#1f2937",
                    fontWeight: "500",
                    }}
                >
                    Foto KTP
                </label>

                <div
                    style={{
                    width: "90%",
                    padding: "18px 20px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "12px",
                    backgroundColor: "#f9fafb",
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    }}
                >
                    <div
                    style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "10px",
                        backgroundColor: "#eef2ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "1.4rem",
                        flexShrink: 0,
                    }}
                    >
                    📷
                    </div>

                    <div style={{ flex: 1 }}>
                    <p
                        style={{
                        margin: 0,
                        fontWeight: "600",
                        color: "#1f2937",
                        marginBottom: "5px",
                        }}
                    >
                        Upload Foto KTP
                    </p>

                    <p
                        style={{
                        margin: 0,
                        fontSize: "0.9rem",
                        color: "#6b7280",
                        }}
                    >
                        {governmentId ? governmentId.name : "Belum ada"}
                    </p>
                    </div>

                    <label
                    htmlFor="government_id"
                    style={{
                        padding: "10px 16px",
                        backgroundColor: "#111827",
                        color: "#fff",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontSize: "0.9rem",
                        fontWeight: "500",
                        whiteSpace: "nowrap",
                    }}
                    >
                    Pilih Foto
                    </label>

                    <input
                    id="government_id"
                    type="file"
                    accept="image/*"
                    onChange={(e) => setGovernmentId(e.target.files[0])}
                    style={{ display: "none" }}
                    />
                </div>
            </div>

            {/* Full Name */}
            <div style={{ marginBottom: "20px" }}>
            <label
                htmlFor="full_name"
                style={{
                display: "block",
                marginBottom: "8px",
                color: "#1f2937",
                fontWeight: "500",
                }}
            >
                Nama Lengkap
            </label>

            <input
                id="full_name"
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Nama Lengkap"
                style={{
                width: "90%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                fontSize: "1rem",
                }}
            />
            </div>

            {/* Address */}
            <div style={{ marginBottom: "20px" }}>
            <label
                htmlFor="address"
                style={{
                display: "block",
                marginBottom: "8px",
                color: "#1f2937",
                fontWeight: "500",
                }}
            >
                Alamat lengkap...
            </label>

            <textarea
                id="address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Your address"
                rows={4}
                style={{
                width: "90%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                fontSize: "1rem",
                resize: "vertical",
                }}
            />
            </div>

            {/* Phone Number */}
            <div style={{ marginBottom: "20px" }}>
            <label
                htmlFor="phone_number"
                style={{
                display: "block",
                marginBottom: "8px",
                color: "#1f2937",
                fontWeight: "500",
                }}
            >
                Nomor HP / Whatsapp
            </label>

            <input
                id="phone_number"
                type="number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="08123456789"
                style={{
                width: "90%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                fontSize: "1rem",
                }}
            />
            </div>

            {/* Error Message */}
            {errorMessage && (
            <p
                style={{
                color: "red",
                fontSize: "0.9rem",
                marginBottom: "15px",
                }}
            >
                {errorMessage}
            </p>
            )}

            {/* Submit Button */}
            <button
            type="submit"
            className="primary-button"
            style={{
                width: "180px",
            }}
            >
            {loading ? "Menambahkan Member..." : "Tambah Member"}
            </button>
        </form>
        </div>
    </div>
  );
}

const backButtonStyle = {
  display: "inline-block",
  padding: "8px 16px",
  backgroundColor: "#f2f6fc",
  color: "#2563eb",
  fontWeight: "500",
  border: "1px solid #d1d5db",
  borderRadius: "6px",
  cursor: "pointer",
  marginBottom: "20px",
  transition: "all 0.2s ease",
};

backButtonStyle[":hover"] = {
  backgroundColor: "#e5e7eb",
};
